import { useDocumentWorkflowDashcard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/Dashcards/useDocumentWorkflowDashcard';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import {
	CHIP_THEME,
	Chips as ChipsV2,
	COLOR,
} from '@dealstack/frontend/shared/components/Chips/Chips.v2';
import { DashCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/DashCard/DashCard';
import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import {
	useTranslationCommonUi,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	className?: string;
}

export const DashcardContract = ({ className }: Props) => {
	const {
		requestedDocument,
		suppliedDocument,
		fullyExecuted,
		completeStatus,
		manageInvestorDetailsController,
	} = useDocumentWorkflowDashcard();

	const tCommonUi = useTranslationCommonUi();
	const tMipManage = useTranslationMipManage();

	const contentArray = [
		{ key: tCommonUi('contracts.documents'), value: `${requestedDocument}` },
		{ key: tCommonUi('contracts.signed.signed'), value: `${suppliedDocument}` },
		{ key: tCommonUi('contracts.fully_executed'), value: `${fullyExecuted}` },
	];

	const onClickScroll = () => {
		manageInvestorDetailsController?.contractTableRef.current?.scrollIntoView();
	};

	const showAwaitingInvestorPill = requestedDocument && !suppliedDocument;
	const showReviewButton = suppliedDocument && requestedDocument !== fullyExecuted;

	let statusElement: React.ReactNode = null;
	if (completeStatus) {
		statusElement = (
			<ChipsV2
				prefixIcon="tick"
				size="s"
				chipTheme={CHIP_THEME.DARK}
				color={COLOR.GREY}
				className={className}
			>
				{tCommonUi('chips.complete')}
			</ChipsV2>
		);
	} else if (showAwaitingInvestorPill) {
		statusElement = (
			<ChipsV2
				size="s"
				color={COLOR.PEACH}
				chipTheme={CHIP_THEME.DARK}
				prefixIcon="hourglass-v3"
				className={className}
			>
				{tMipManage('investors.details.dashcards.kyc.awaiting_investor')}
			</ChipsV2>
		);
	}

	return (
		<DashCard className={className}>
			<DashCard.Top textVariant="sans/14/600" icon="document-v3">
				{tMipManage('investors.dashcards.document_signature_status')}
			</DashCard.Top>
			<DashCard.Divider />
			<DashCard.Middle
				content={contentArray}
				status={statusElement}
				button={
					showReviewButton && (
						<UIElementIdentifier
							identifier={
								TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_CONTRACT_REVIEW_BUTTON
							}
						>
							<ButtonV2
								size="xs"
								buttonTheme="light"
								variant="primary"
								icon="view-v3"
								leftIcon
								onClick={onClickScroll}
								className={className}
							>
								{tMipManage('investors.details.dashcards.kyc.review_button')}
							</ButtonV2>
						</UIElementIdentifier>
					)
				}
			/>
		</DashCard>
	);
};
